/**
 * 获取界面筛选数据
 *
 */

export function taskInfoSearchData(tipsData, productList, clientCondition) {
  if (tipsData == "") {
    tipsData = {
      clientTipsList: [],
      clientLevelList: [],
    };
  }
  let data = [
    {
      title: "服务产品",
      type: "cascader",
      hasSearch: false,
      flag: "0",
      key: "servicesTypeOrItem",
      value: [],
      // value: ["1b7e460bcd904d098d88d4915f56e209", "34a3886be0864f8788a39e778dc5a164"],
      options: productList,
    },
    {
      title: "增值税类型",
      type: "tip",
      hasSearch: false,
      flag: "0",
      key: "addedValueTaxType",
      value: [
        { text: "一般纳税人", is_active: false, id: "" },
        { text: "小规模纳税人", is_active: false, id: "" },
      ],
    },
    {
      title: "是否是开票客户",
      type: "radio",
      flag: "0",
      hasSearch: false,
      key: "isInvoicing",
      value: "",
    },
    {
      title: "是否包含社保",
      type: "radio",
      flag: "0",
      hasSearch: false,
      key: "isSocialSecurity",
      value: "",
    },
    {
      title: "是否包含流水",
      type: "radio",
      flag: "0",
      hasSearch: false,
      key: "isStatement",
      value: "",
    },
    {
      title: "客户标签",
      type: "tip",
      flag: "0",
      hasSearch: true,
      key: "clientTips",
      search_value: "",
      value: [],
      options: tipsData.clientTipsList,
    },
    {
      title: "客户等级",
      type: "tip",
      flag: "0",
      hasSearch: true,
      key: "clientLevel",
      search_value: "",
      value: [],
      options: tipsData.clientLevelList,
    },
  ];
  data.forEach((item) => {
    clientCondition.forEach((it) => {
      if (item.key == it.key) {
        if (item.addedValueTaxType == "addedValueTaxType") {
          it.value.forEach((value) => {
            let index = item.value.findIndex(
              (find) => find.text === value.text,
            );
            item.value[index].is_active = value.is_active;
          });
        } else {
          item.value = it.value;
        }
      }
    });
  });
  return data;
}

export function addScheduleDialog(
  options,

  isClient,
) {
  let data = [
    {
      type: "input",
      title: "日程名称",
      key: "title",
      value: "",
      required: true,
    },
    {
      type: "filters",
      title: "参与人",
      key: "",
      value: [],
      required: true,
      data: {
        playersType: "1", // 参与者类型（'1'-人员；'2'-角色；'3'-部门）
        departmentIds: [], // 选择的部门
        visibleUsers: [], // 具体可见用户集合（JSON字符串），如果参与者类型是 '1' 则该字段必填
        businessRole: [], // 选择的业务角色
        clientConditionFlag: true, // 是否可见客户范围
        clientCondition: [], // 客户范围的筛选条件信息（JSON字符串）
        visibleUsersList: options.visibleUsersList, // 下拉选项 可选人员列表
        businessRoleList: options.businessRoleList, // 下拉选项 可选业务角色列表
        departmentList: options.departmentList, // 下拉选项 可选部门列表
      },
    },
    {
      type: "time_date_scope",
      title: "日程时间",
      key: "time",
      value: [],
      required: true,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        },
      },
    },
    {
      type: "select",
      title: "日程重复",
      key: "repeatRule",
      value: "不重复",
      options: [
        {
          label: "不重复",
          value: "不重复",
        },
        {
          label: "每周重复",
          value: "每周",
        },
        {
          label: "每半个月重复",
          value: "每半个月",
        },
        {
          label: "每月重复",
          value: "每月",
        },
        {
          label: "每两个月重复",
          value: "每两个月",
        },
        {
          label: "每季度重复",
          value: "每季度",
        },
        {
          label: "每半年重复",
          value: "每半年",
        },
        {
          label: "每年重复",
          value: "每年",
        },
      ],
      required: true,
    },
    {
      type: "select",
      title: "完成方式",
      key: "completeMethod",
      value: "1",
      options: [
        {
          label: "逐步完成",
          value: "1",
        },
        {
          label: "同步完成",
          value: "2",
        },
      ],
      required: true,
    },
    {
      type: "select",
      title: "推送提醒",
      key: "remind",
      value: "",
      clearable: true,
      options: [
        {
          label: "每天",
          value: "1",
        },
        {
          label: "每两天",
          value: "2",
        },
        {
          label: "每三天",
          value: "3",
        },
        {
          label: "每周提醒",
          value: "7",
        },
      ],
    },
    {
      type: "textarea",
      title: "日程内容",
      key: "content",
      value: "",
      placeholder: "请输入日程内容",
    },
  ];

  if (isClient) {
    data[0] = {
      type: "select",
      title: "日程事项",
      key: "title",
      value: "",
      options: options.workList,
      required: true,
    };
  }
  return data;
}
